module.exports = "//d274d294w9cx2v.cloudfront.net/905403f404c5e7b6ac030f326dec9ecd02f1ba31/images/photo-single.png";